import { render, staticRenderFns } from "./FacturationModalEdit.vue?vue&type=template&id=2ba0522f"
import script from "./FacturationModalEdit.vue?vue&type=script&lang=ts"
export * from "./FacturationModalEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports